<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" v-show="currentModal==='comfirm'">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title" style="width:100%">確認家戶成員身份</h3>
        </div>
        <div class="modal-body" v-show="currentModal==='select'">
          <div class="row my-4">
            <div class="col-12">
              <form class="form">
                <div class="input-group input-lg">
                  <div class="input">
                    <input
                      type="text"
                      name="keyword"
                      id="keyword"
                      class="form-control"
                      v-model="keyword"
                      placeholder="輸入姓名、身分證或保單號碼進行搜尋..."
                      maxlength="100"
                      @input="checkInputKeyword"
                      @blur="checkInputKeyword"
                    />
                  </div>
                  <button
                    class="btn btn-primary btn-icon"
                    type="submit"
                    @click.prevent="doSearch()"
                  >
                    <i class="icon-search i-24"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="row row-tables newTable select">
            <div class="col-table pr-0">
              <h5>可選擇的客戶名單</h5>
              <table id="customer-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th
                      :width="Math.floor(344 * 0.26) + 'px'"
                      class="sort"
                      @click="sortArray('unselected','name')"
                    >姓名</th>
                    <th
                      :width="Math.floor(344 * 0.32) + 'px'"
                      class="sort"
                      @click="sortArray('unselected','identity')"
                    >身分證</th>
                    <th
                      :width="Math.floor(344 * 0.25) + 'px'"
                      class="sort"
                      @click="sortArray('unselected','birthday')"
                    >生日</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in families" :key="`familiy-item-${i}`">
                    <td :width="Math.floor(344 * 0.26) + 'px'">
                      <Tooltip
                        position="right"
                        :name="item.name"
                        :id="item.personalid.includes('~') || item.personalid.includes('#') ? '' : item.personalid"
                        :birthday="item.birthday"
                        :key="`unSelectedFamiliy-item-${item.personalid}`"
                      >
                        <span v-text="getMaskName(`${item.name}`)"></span>
                      </Tooltip>
                    </td>
                    <td :width="Math.floor(344 * 0.32) + 'px'">
                      <div v-if="item.personalid.includes('~') || item.personalid.includes('#')"></div>
                      <div v-else>{{item.personalid | getMaskID}}</div>
                    </td>
                    <td :width="Math.floor(344 * 0.25) + 'px'">{{item.birthday | dateFormat | getMaskBirthday}}</td>
                    <td class="action-button">
                      <a class="text-orange" @click="addGroup(i)">
                        <i class="icon-add_new i-20"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="px-2 text-light-green text-center col-split">
              <i class="icon-forward"></i>
            </div>
            <div class="col-table">
              <h5>
                選擇加入
                <a class="link text-underline">{{customer.name}}</a> 家戶的名單
              </h5>
              <table id="new-group-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th
                      :width="Math.floor(344 * 0.26) + 'px'"
                      class="sort"
                      @click="sortArray('selected','name')"
                    >姓名</th>
                    <th
                      :width="Math.floor(344 * 0.32) + 'px'"
                      class="sort"
                      @click="sortArray('selected','identity')"
                    >身分證</th>
                    <th
                      :width="Math.floor(344 * 0.25) + 'px'"
                      class="sort"
                      @click="sortArray('selected','birthday')"
                    >生日</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in selectedFamily" :key="`familiy-item-${i}`">
                    <td :width="Math.floor(344 * 0.26) + 'px'">
                      <Tooltip
                        position="right"
                        :name="item.name"
                        :id="item.personalid.includes('~') || item.personalid.includes('#') ? '' : item.personalid"
                        :birthday="item.birthday"
                        :key="`selectedFamiliy-item-${item.personalid}`"
                      >
                        <span v-text="getMaskName(`${item.name}`)"></span>
                      </Tooltip>
                    </td>
                    <td :width="Math.floor(344 * 0.32) + 'px'">
                      <div v-if="item.personalid.includes('~') || item.personalid.includes('#')"></div>
                      <div v-else>{{item.personalid | getMaskID}}</div>
                    </td>
                    <td :width="Math.floor(344 * 0.25) + 'px'">{{item.birthday | dateFormat | getMaskBirthday}}</td>
                    <td class="action-button">
                      <a class="text-red" @click="removeGroup(i)">
                        <i class="icon-trashcan i-20"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <button @click="$emit('close')" class="btn btn-default">取消加入</button>
                <button @click="goToPage('comfirm')" class="btn btn-primary">加入</button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body" v-show="currentModal==='comfirm'">
          <div class="row newTable comfirm">
            <div class="col-md-12">
              <h5>本次加入的成員：</h5>
              <table id="customer-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>身分</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in selectedFamily" :key="`familiy-item-${item.personalid}`">
                    <td>{{item.name}}</td>
                    <td class="action-button">
                      <span class="text">
                        <select
                          v-model="item.relation"
                          class="form-control form-control-inline form-short"
                        >
                          <option value="">請選擇</option>
                          <option
                            v-for="(role, j) in roleOpt"
                            :value="(j+1).toString()"
                            :key="`role-select-${j}`"
                          >{{role}}</option>
                        </select>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row newTable comfirm">
            <div class="col-md-12">
              <h5>家戶成員列表:</h5>
              <table id="new-group-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>身分</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in familiesSelect" :key="`familiy-item-${item.personalid}`">
                    <td>{{item.name}}</td>
                    <td>
                      <div v-if="item.relation === `0`">戶長</div>
                      <div v-else>{{roleOpt[item.relation - 1]}}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <button @click="goToPage('select')" class="btn btn-default">上一步</button>
                <button
                  @click="checkSelectedFamily"
                  :disabled="!isRelationSelected"
                  class="btn btn-primary"
                >確認</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <recommand-modal
      :open="RecommandModalOpen"
      :targetUrl="``"
      :baseFamily="selectedFamily"
      @submit="submitAddFamily"
      @close="panelClose('RecommandModalOpen')"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import RecommandModal from '@/desktop/components/RecommandModal'
import { commonMixin } from "../../mixins/common"
import Tooltip from "@/desktop/components/ToolTip"
export default {
  name: "AddFamilyModal",
  mixins: [commonMixin],
  components: { RecommandModal, Tooltip},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: () => {
        return {
          name: ""
        };
      }
    },
    selectedCustomer: {
      type: Object,
      default: {
        age: "",
        birthday: "",
        guid: "",
        householderid: "",
        link: "",
        name: "",
        personalid: "",
        relation: "",
        sex: ""
      }
    },
    familiesInsertList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    familiesSelect: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    open: "modalChange"
  },
  data() {
    return {
      isRelationSelected: false,
      keyword: "",
      currentModal: "select",
      customerTable: null,
      selectedTable: null,
      selectedFamily: [],
      families: [],
      roleOpt: ["配偶", "子女", "父母", "其他", "孫子女"],
      unselectedSort: true,
      RecommandModalOpen: false
    };
  },
  methods: {
    //檢查關鍵字
    checkInputKeyword(){
      this.keyword = this.keyword.replace(/[<>!@#$^&,."'?%;()+-/_{}[\]|~`=\\]/g,'');
      if (this.stringBytes(this.keyword, false, 100) > 100) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true ,100));
      }      
    },
    ...mapActions([
      'setPageLock'
    ]),
    addGroup(index) {
      this.selectedFamily.push({
        ...this.families.splice(index, 1)[0],
        relation: ""
      });
      this.sortArray();
    },
    removeGroup(index) {
      this.families.push(this.selectedFamily.splice(index, 1)[0]);
      this.sortArray();
    },
    // 排序陣列
    sortArray(arrayName, arrayPorp = "name") {
      if (arrayName === "unselected") {
        if (this.unselectedSort && this.unselectedItem === arrayPorp) {
          this.unselectedSort = !this.unselectedSort;
          this.families = this.families.sort(function(a, b) {
            return b[arrayPorp] >= a[arrayPorp] ? 1 : -1;
          });
        } else {
          this.unselectedItem = arrayPorp;
          this.unselectedSort = true;
          this.families = this.families.sort(function(a, b) {
            return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
          });
        }
      } else if (arrayName === "selected") {
        if (this.selectedSort && this.selectedItem === arrayPorp) {
          this.selectedSort = !this.selectedSort;
          this.selectedFamily = this.selectedFamily.sort(function(a, b) {
            return b[arrayPorp] >= a[arrayPorp] ? 1 : -1;
          });
        } else {
          this.selectedItem = arrayPorp;
          this.selectedSort = true;
          this.selectedFamily = this.selectedFamily.sort(function(a, b) {
            return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
          });
        }
      } else {
        this.families = this.families.sort(function(a, b) {
          return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
        });
        this.selectedFamily = this.selectedFamily.sort(function(a, b) {
          return a[arrayPorp] >= b[arrayPorp] ? 1 : -1;
        });
      }
      setTimeout(() => {
        this.registerHanlink();
      }, 200);
    },
    refreshData() {
      this.families = this.filterOutById(this.custsOfAgnt, this.custsOfGrp);
      // this.selectedFamily = this.custsOfGrp
      this.sortArray();
    },
    doSearch() {
      if (this.keyword.trim() != "") {
        let searchCusts = this.familiesInsertList.filter(
          item =>
            item.name.includes(this.keyword) ||
            item.personalid.includes(this.keyword)
        );
        this.families = this.filterOutById(searchCusts, this.selectedFamily);
      } else {
        this.families = this.filterOutById(
          this.familiesInsertList,
          this.selectedFamily
        );
      }
      setTimeout(() => {
        this.registerHanlink();
      }, 200);
    },
    filterOutById(allCusts, targetCusts) {
      let idOfTargetCusts = new Set(targetCusts.map(cust => cust.personalid));
      let filteredCusts = allCusts.filter(
        cust => !idOfTargetCusts.has(cust.personalid)
      ).map(item => {
        // 讓RecommandModal可篩選
        item['dataexist'] = true
        return item
      });
      return filteredCusts;
    },
    goToPage(pageName) {
      this.currentModal = pageName;
    },
    modalChange(value) {
      this.currentModal = "select";
      let selectData = [];
      if (this.selectedCustomer) {
        selectData = [this.selectedCustomer];
      }
      this.selectedFamily = [...selectData];
      let familiesData = [...this.familiesInsertList];

      this.families = this.filterOutById(familiesData, selectData);
      this.sortArray();//預設排序
      setTimeout(() => {
        this.registerHanlink();
      }, 200);
    },
    checkSelectedFamily() {
      // 開啟確認家戶成員的生日與性別
      this.RecommandModalOpen = true
      this.panelOpen('RecommandModalOpen')
    },
    submitAddFamily(updatefamilyList) {
      // 設定年齡、性別、生日
      if (updatefamilyList) {
        let cThis = this;
        updatefamilyList.forEach(uf => {
          cThis.selectedFamily.forEach(sf => {
            if (sf.personalid === uf.csid) {
              sf.sex = uf.sex;
              sf.birthday = (uf.year !== '' && uf.month !== '' && uf.day !== '') ? `${uf.year}-${uf.month}-${uf.day}` : `9999/12/31`
              sf.age = uf.countAge;
            }
          });
        });
      }

      // 確認家戶成員生日與性別後，呼叫回submit
      this.RecommandModalOpen = false
      this.panelClose('RecommandModalOpen')
      this.$emit('submit', this.selectedFamily)
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    },
    //姓名資安遮蔽
    getMaskName(val){
      if (val && val.trim() && val !== '— —') {
        let maskName = ''
        let pattern = /^[A-Za-z]+$/
        val = val.trim()
        let len = val.length
        if (pattern.test(val)) {
          //姓名為英文拼音
          if(len <= 4) {
            //長度未超過4不處理
            maskName = val
          } else {
            maskName = val.substring(0, 4)
            let c = len > 8 ? 8 : 4
            for (let i = 0; i < len - c; i++) {
              maskName += 'O'
            }
            maskName += val.substring(len - 4, len)
          }
        } else {
          if (len === 2) {
            maskName = val.substring(0, 1) + 'O'
          } else if (len === 3) {
            maskName = val.substring(0, 1) + 'O' + val.substring(2, 3)
          } else if (len >= 4) {
            maskName = val.substring(0, 2)
            for (let i = 0; i < len - 3; i++) {
              maskName += 'O'
            }
            maskName += val.substring(len - 1, len)
          }
        }
        return maskName
      } else {
        return val
      }
    }
  },
  updated() {
    //因資料更新，而更新 DOM
    let isAllSelected = true;
    this.selectedFamily.forEach(el => {
      if (el.relation === "") {
        isAllSelected = false;
      }
    });
    this.isRelationSelected = isAllSelected;
  }
};
</script>

<style lang="scss" scoped>
h5 {
  margin-top: 0;
}

.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.actions {
  .btn {
    margin: 0;
    width: 120px;
  }
  .btn:not(:last-of-type) {
    margin-right: 20px;
  }
}

.close {
  position: absolute;
  right: -12px;
  top: -12px;
  display: block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 22px;
  color: white;
  background: #5b616a;
  border: 2px solid #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  -ms-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  -o-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
}

table.table.insurance-green > thead > tr {
  border-top-width: 0px !important;
  border-left-width: 0px !important;
  border-right-width: 0px !important;
  border-bottom-width: 0px !important;
  & > th {
    text-align: left;
    padding: 9px 6px !important;
    border-right: 1px dotted #c2c4c7 !important;
    border-left-width: 0px !important;
    border-bottom-width: 0px !important;
    font-size: 15px;
    z-index: 9;

    &:last-of-type {
      border-right-width: 0px !important;
    }
  }
}

.newTable {
  tr:first-of-type {
    td {
      border-top-width: 0;
    }
  }

  tr {
    td:first-of-type {
      border-left-width: 0;
    }

    td:last-of-type {
      border-right-width: 0;
    }
  }

  &.select {
    tbody {
      height: 400px;
    }
  }

  thead {
    border: 1px solid #53c480;
    background: #e5f6ec;
  }

  tbody {
    tr {
      td {
        border-bottom-width: 0;
        border-top-width: 0;
      }

      td:first-of-type {
        border-right: 1px dotted #c2c4c7 !important;
      }

      td:last-of-type {
        border-left: 1px dotted #c2c4c7 !important;
      }
    }
  }

  &.comfirm {
    th,
    td {
      max-width: 350px;
    }
    tbody {
      min-height: 115px;
      max-height: 200px;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 16px;
        border: 0;
        box-shadow: none;
      }

      &::-webkit-scrollbar-track {
        box-shadow: none;
        border-radius: 0px;
        border: 0;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        width: 10px;
        border-radius: 20px;
        background-color: #555;
      }
    }

    &:first-of-type {
      margin-bottom: 20px;
    }

    thead {
      border: 1px solid #53c480;
      background: #e5f6ec;
      tr {
        padding-right: 16px;
        display: table;
        width: calc(100% - 16px);
        table-layout: fixed;
      }

      th:last-of-type {
        border-width: 0;
      }
    }
  }

  th {
    position: relative;
    &.sort::after {
      position: absolute;
      content: "";
      top: 15px;
      right: 9px;
      border-top: 6px solid rgba(2, 122, 57, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }
  }

  tbody {
    display: block;
    overflow-y: scroll;
    scrollbar-width: none;
    border: 0 !important;
    -webkit-overflow-scrolling: touch;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .newTable.comfirm thead {
    tr {
      width: calc(100%);
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .newTable.comfirm thead {
    tr {
      width: calc(100%);
    }
  }
}

@media only screen and (-webkit-min-device-pixel-ratio: 1) and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
  .newTable.comfirm thead {
    tr {
      width: calc(100%);
    }
  }
}
</style>